import React from "react"
import { View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"
import CustomScrollableContentWithBackHeader from "@Components/CustomScrollableContentWithBackHeader/CustomScrollableContentWithBackHeader"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseFontFamily } from "@Constants/baseStyles"
import { references } from "@Constants/fakeData"

const References = () => {
    return (
        <CustomScrollableContentWithBackHeader>
            <View style={styles.header}>
                <BreeSerifText style={styles.title} fontSize={RFValue(24)}>
                    Références scientifiques{" "}
                </BreeSerifText>

                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansRegular} fontSize={RFValue(16)}>
                    Découvrez diverses sources et références relatives à l’éducation thérapeutique.{" "}
                </OpenSansText>
            </View>

            <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(16)}>
                IVEHTE a pour objectif de vous accompagner dans la prise en charge de votre maladie cardiovasculaire.
            </OpenSansText>

            <View style={styles.content}>
                {references.map((reference, i) => (
                    <View key={i}>
                        <BreeSerifText style={styles.title} fontSize={RFValue(18)}>
                            {reference.title}
                        </BreeSerifText>
                        {reference.data.map((item, j) => (
                            <View key={j} style={styles.item}>
                                <OpenSansText
                                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                    fontSize={RFValue(16)}
                                >
                                    {item.content}
                                </OpenSansText>
                            </View>
                        ))}
                    </View>
                ))}
            </View>
        </CustomScrollableContentWithBackHeader>
    )
}

export default References
